export default __webpack_public_path__ + "static/media/CrossIcon.2ed57c14.svg";